// noinspection DuplicatedCode

import axios from 'axios';

const url = '/api/partners';

const PartnerService = {
  getAll(filter = '') {
    return axios.get(url, filter.length > 0 ? { params: { filter } } : null);
  },
  getOneById(id) {
    return axios.get(`${url}/${id}`);
  },
  deleteById(id) {
    return axios.delete(`${url}/${id}`);
  },
  add(data) {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      if (key === 'file') {
        if (data[key][0]) {
          formData.append(key, data[key][0]);
        }
      } else if (typeof data[key] !== 'object') {
        formData.append(key, data[key]);
      }
    });

    Object.keys(data.address).forEach((objectKey) => {
      formData.append(`address.${objectKey}`, data.address[objectKey]);
    });

    data.socialMedia.forEach((socialMedia, index) => {
      Object.keys(socialMedia).forEach((key) => {
        formData.append(`socialMedia[${index}].${key}`, socialMedia[key]);
      });
    });
    data.specialties.forEach((specialty, index) => {
      formData.append(`specialties[${index}]`, specialty);
    });
    return axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  update(id, data) {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      if (key === 'file') {
        if (data[key][0]) {
          formData.append(key, data[key][0]);
        }
      } else if (typeof data[key] !== 'object') {
        formData.append(key, data[key]);
      }
    });

    Object.keys(data.address).forEach((objectKey) => {
      formData.append(`address.${objectKey}`, data.address[objectKey]);
    });

    data.socialMedia.forEach((socialMedia, index) => {
      Object.keys(socialMedia).forEach((key) => {
        formData.append(`socialMedia[${index}].${key}`, socialMedia[key]);
      });
    });
    data.specialties.forEach((specialty, index) => {
      formData.append(`specialties[${index}]`, specialty);
    });
    return axios.put(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};

export default PartnerService;
